import { useState } from 'react';
import { Menu } from '@pocketlaw/tetris';
import { MenuFooter } from './MenuFooter';
export function InputText(props) {
    const { property, initialValue, onChange, onClear, multiline } = props;
    const { label } = property;
    const [value, setValue] = useState(initialValue || '');
    const handleClear = () => {
        onClear(property);
    };
    const handleSetValue = (event) => {
        setValue(event.target.value);
    };
    return (<Menu.ItemNested target={label}>
      {multiline ? (<Menu.TextArea value={value} label={label} onChange={handleSetValue}/>) : (<Menu.TextInput value={value} label={label} onChange={handleSetValue}/>)}
      <MenuFooter onClear={handleClear} onSave={() => onChange(property, value)}/>
    </Menu.ItemNested>);
}
